import type { AudienceSegmentTagGroups } from '@openx/types/gqlTypes';
import { audienceSegmentTagGroupOperator } from '../constants';

export const mapTagGroups = (tagGroups?: AudienceSegmentTagGroups) => {
  const raw = tagGroups ?? { operator: audienceSegmentTagGroupOperator.AND, groups: [] };
  const stripTypename = <T>(value: T): T => {
    if (Array.isArray(value)) return value.map(stripTypename) as T;
    if (value !== null && typeof value === 'object') {
      const { __typename: _, ...rest } = value as object & { __typename?: string };
      return Object.fromEntries(Object.entries(rest).map(([k, v]) => [k, stripTypename(v)])) as T;
    }
    return value;
  };
  return stripTypename(raw);
};
